"use strict";

export { default } from './BottomSheetTextInput';
//# sourceMappingURL=index.js.map